// extracted by mini-css-extract-plugin
export default {"battleCollection":"BattleCollection_battleCollection__3l5mM"};